import React from 'react';

const PosterBlock = (props) => {
  return (
    <div className="loginLeftBlock">
      <img src={props.left} alt="" />
      {/* <video autoPlay loop>
            <source src={require("../../assets/img/login/video1.mp4")}></source>
          </video> */}
      {/* <div className="loginLeftBlockInner">
            <div className="loginLeftWrapper">
              <div className="loginLeftOverlay"></div>
              <div className="loginLeftContent">
                <h2>SL  Diamonds</h2>
              </div>
              <div className="loginBasicList">
                <ul>
                  <li>
                    <a href="news">News & Event</a>
                  </li>
                  <li>
                    <a href="/bidding-procedure">Bidding Procedure</a>
                  </li>
                  <li>
                    <a href="SL KYC FORM.xls" download>
                      Download KYC Form
                    </a>
                  </li>
                  <li>
                    <a href="/book-appointment">Take Appointment</a>
                  </li>
                  <li>
                    <a href="/terms-condition">Terms</a>
                  </li>
                </ul>
              </div>
            </div>
          </div> */}
    </div>
  );
};
export default PosterBlock;
